module.exports = __webpack_public_path__ + "img/天秤座.33cc934f.svg";